import React, { useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useFont } from "../context/FontContext"; // Eğer context yapın farklıysa burayı kontrol et

const styles = {
    container: { maxWidth: '800px', margin: '40px auto', padding: '30px', borderRadius: '15px', backgroundColor: '#fff', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', fontFamily: 'Segoe UI, sans-serif' },
    header: { textAlign: 'center', marginBottom: '30px', color: '#333' },
    scenarioBox: { backgroundColor: '#f0f4f8', padding: '25px', borderRadius: '10px', borderLeft: '5px solid #6c5ce7', fontSize: '20px', lineHeight: '1.6', marginBottom: '25px', color: '#2d3436' },
    optionBtn: { display: 'block', width: '100%', padding: '20px', margin: '15px 0', border: '2px solid #e1e4e8', borderRadius: '10px', backgroundColor: '#fff', fontSize: '18px', cursor: 'pointer', transition: '0.2s', textAlign: 'left', color: '#444' },
    startBtn: { padding: '15px 50px', fontSize: '18px', backgroundColor: '#00b894', color: 'white', border: 'none', borderRadius: '50px', cursor: 'pointer', marginTop: '20px', fontWeight: 'bold', boxShadow: '0 4px 15px rgba(0, 184, 148, 0.4)' },
    resultBox: { padding: '40px', borderRadius: '15px', textAlign: 'center', marginTop: '20px' },
    scoreBadge: { position: 'absolute', top: '20px', right: '20px', backgroundColor: '#dfe6e9', padding: '5px 15px', borderRadius: '20px', fontWeight: 'bold' }
};

export default function CareerSim() {
    const { fontSize } = useFont();
    const location = useLocation();
    const navigate = useNavigate();

    // Rapor sayfasından gelen meslek adı yoksa varsayılanı kullan
    const initialJob = location.state?.jobName || "Yazılım Mühendisi";
    const [job, setJob] = useState(initialJob);
    
    const [gameState, setGameState] = useState("intro"); 
    const [currentNode, setCurrentNode] = useState(null);
    const [currentScore, setCurrentScore] = useState(0);
    const [finalResult, setFinalResult] = useState(null);
    const [loading, setLoading] = useState(false);

    // 1. OYUNU BAŞLAT
    const startGame = async () => {
        setLoading(true);
        try {
            console.log("Simülasyon isteniyor:", job);
            // Frontend, Backend ile HTTP üzerinden konuşur. Kütüphane import etmez.
            const res = await axios.post('http://localhost:5001/simulate-career', {
                job: job,
                action: "start"
            });
            
            console.log("Başlangıç verisi geldi:", res.data);
            setCurrentNode(res.data);
            setGameState("playing");
            setCurrentScore(0);
        } catch (error) {
            console.error("Başlatma Hatası:", error);
            alert("Simülasyon başlatılamadı. Backend (5001 portu) açık mı?");
        } finally {
            setLoading(false);
        }
    };

    // 2. CEVAP VER
    const handleAnswer = async (index) => {
        if (!currentNode) return;
        setLoading(true);
        
        try {
            const res = await axios.post('http://localhost:5001/simulate-career', {
                job: job,
                action: "answer",
                currentNodeId: currentNode.nodeId, 
                optionIndex: index,
                currentScore: currentScore
            });

            if (res.data.type === "result") {
                setFinalResult(res.data);
                setGameState("finished");
            } else {
                setCurrentNode(res.data);
                setCurrentScore(res.data.totalScore);
            }

        } catch (error) {
            console.error("Cevap Hatası:", error);
            alert("Bir hata oluştu. Lütfen tekrar deneyin.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{...styles.container, position: 'relative'}}>
            
            {/* Skor */}
            {gameState === "playing" && (
                <div style={styles.scoreBadge}>Puan: {currentScore}</div>
            )}

            {/* GİRİŞ */}
            {gameState === "intro" && (
                <div style={{textAlign: 'center'}}>
                    <h1 style={{...styles.header, fontSize: `${fontSize + 12}px`}}>🎭 Kariyer Simülasyonu</h1>
                    <p style={{fontSize: `${fontSize + 4}px`, marginBottom: '20px'}}>
                        Seçilen Meslek: <strong style={{color: '#6c5ce7'}}>{job}</strong>
                    </p>
                    <p style={{color: '#636e72', marginBottom: '30px', fontSize: `${fontSize}px`}}>
                        Bu simülasyonda, {job} mesleğinde karşılaşabileceğin gerçek kriz senaryolarını yönetecek ve kararlarının sonuçlarını göreceksin.
                    </p>
                    <button onClick={startGame} style={styles.startBtn} disabled={loading}>
                        {loading ? "Yükleniyor..." : "Maceraya Başla ▶"}
                    </button>
                    <div style={{marginTop: '20px'}}>
                        <small>Farklı bir meslek dene:</small><br/>
                        <select value={job} onChange={(e) => setJob(e.target.value)} style={{marginTop: '10px', padding: '5px'}}>
                            <option value="Yazılım Mühendisi">Yazılım Mühendisi</option>
                            <option value="Doktor">Doktor</option>
                            <option value="Avukat">Avukat</option>
                            <option value="Genel">Genel</option>
                        </select>
                    </div>
                </div>
            )}

            {/* OYUN */}
            {gameState === "playing" && currentNode && (
                <div>
                    <div style={{marginBottom: '10px', color: '#636e72', fontWeight: 'bold'}}><span>Senaryo</span></div>
                    <div style={{...styles.scenarioBox, fontSize: `${fontSize + 2}px`}}>{currentNode.text}</div>
                    <h3 style={{color: '#2d3436', fontSize: `${fontSize + 2}px`}}>Kararın Nedir?</h3>
                    {currentNode.options.map((opt, i) => (
                        <button key={i} onClick={() => handleAnswer(i)} style={{...styles.optionBtn, fontSize: `${fontSize}px`}} disabled={loading}>
                            {loading ? "..." : `👉 ${opt.text}`}
                        </button>
                    ))}
                </div>
            )}

            {/* SONUÇ */}
            {gameState === "finished" && finalResult && (
                <div style={{...styles.resultBox, backgroundColor: finalResult.isSuccess ? '#d4edda' : '#fff3cd', color: finalResult.isSuccess ? '#155724' : '#856404'}}>
                    <h1 style={{fontSize: `${fontSize + 14}px`}}>{finalResult.isSuccess ? "🎉 BAŞARDIN!" : "💀 OYUN BİTTİ"}</h1>
                    <p style={{fontSize: `${fontSize + 4}px`, fontWeight: 'bold'}}>Toplam Puan: {finalResult.finalScore}</p>
                    <div style={{backgroundColor: 'rgba(255,255,255,0.7)', padding: '20px', borderRadius: '10px', marginTop: '20px', fontSize: `${fontSize + 2}px`}}>{finalResult.feedback}</div>
                    <button onClick={() => setGameState("intro")} style={{...styles.startBtn, backgroundColor: '#2d3436'}}>🔄 Tekrar Dene</button>
                    <br/><br/>
                    <button onClick={() => navigate('/ai-report')} style={{background: 'none', border: 'none', textDecoration: 'underline', cursor: 'pointer', color: '#636e72', fontSize: fontSize}}>Raporuma Dön</button>
                </div>
            )}
        </div>
    );
}